const firebaseConfig = {
    apiKey: "AIzaSyCorVRtK3FmDsTVEZ3FHjzEJDYiXxfF0-o",
    authDomain: "volunteer-network-firebase.firebaseapp.com",
    databaseURL: "https://volunteer-network-firebase.firebaseio.com",
    projectId: "volunteer-network-firebase",
    storageBucket: "volunteer-network-firebase.appspot.com",
    messagingSenderId: "871235038601",
    appId: "1:871235038601:web:1ba3f8af433142f7430558"
  };

  export default firebaseConfig;